import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../helpers/Firebase';
import { servicePath } from '../../constants/defaultValues';
import { NotificationManager } from '../../components/common/react-notifications';
import {
    MARKETINTEL_SUPPLIER_LIST
} from '../actions';

import {
    MarketintelSupplierListSuccess,
    MarketintelSupplierListError
} from '../actions';

export function* watchMarketintelSupplierList() {
    yield takeEvery(MARKETINTEL_SUPPLIER_LIST, onMarketintelSupplierList);
}

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onMarketintelSupplierListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'marketintel_supplier/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

function* onMarketintelSupplierList(data) {
    try {
        const response = yield call(onMarketintelSupplierListAsync, data.payload);
        yield put(MarketintelSupplierListSuccess(response.data));
    } catch (error) {
        yield put(MarketintelSupplierListError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchMarketintelSupplierList)
    ]);
}
